import React, { useEffect, useState } from 'react'
import { Link, useLocation, useRouteMatch } from 'react-router-dom'

import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Menu,
    MenuItem,
    Button,
    Avatar,
    makeStyles,
    Grid,
} from '@material-ui/core'
import { AccountCircle, Menu as MenuIcon } from '@material-ui/icons'

import { ReactComponent as CapeeshLogo } from 'assets/images/capeesh_logo.svg'
import { ReactComponent as CapeeshIcon } from 'assets/images/capeesh_icon.svg'

import { connect } from 'react-redux'
import { useIntl } from 'react-intl'

import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/styles'
import { studentActions } from '../../../_state/actions'

import { CapeeshColors } from '../../../assets/ColorPalette'

import { StudentMonoPageSubPages, switchToStudentSubPage } from 'Logic/Student/StudentQueryParamParser'
import { GlobalEvents } from '../../../assets/GlobalEvents'
import { CapeeshLanguage } from '../../../Logic/CapeeshConstants'
import LocalizationSelector from '../../../Components/LocalizationSelector/LocalizationSelector'
import { studentScreenMessages } from '../StudentScreen.i18n.Messages'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        // height: '98px',
        top: 0,
        position: 'fixed',
        zIndex: 100,
    },
    appBar: {
        position: 'relative',
        padding: '0px 20px 0px 20px',
        //boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.08)",
    },
    toolBar: {
        padding: '0px',
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    title: {
        display: 'none',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    capeeshLogo: {
        position: 'relative',
        height: '64px',
        width: '150px',
        cursor: 'pointer',
        transition: 'all 150ms',
        boxShadow: 'none',
        fill: theme.palette.primary.contrastText,
    },
    capeeshIcon: {
        position: 'relative',
        height: '42px',
        width: '42px',
        cursor: 'pointer',
        transition: 'all 150ms',
        boxShadow: 'none',
        overflow: 'visible',
        fill: theme.palette.primary.contrastText,
    },
    logoButton: {
        height: '64px',
        padding: '0',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0)',
        },
    },
    username: {
        margin: 'auto 5px',
        color: theme.palette.primary.contrastText,
    },

    dropdownMenu: {
        marginTop: 35,
    },
    profileButton: {
        borderRadius: '5px',
    },
    breadcrumbs: {
        position: 'relative',
        padding: '5px 20px 5px 20px',
    },
    breadcrumb: {
        letterSpacing: '0.41px',
        textTransform: 'none',
        color: 'inherit',
        alignItems: 'center',
        display: 'flex',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    languageSelectorItem: {
        display: 'flex',
        alignItems: 'center',
    },
    hamburgerButton: {
        color: '#fff',
        marginRight: 8,
    },
}))

const MenuOptionType = {
    Logout: 0,
    Link: 1,
    QueryParam: 2,
    FunctionCall: 3,
}

const StudentTopBar = (props) => {
    const { user } = props
    const classes = useStyles()
    const location = useLocation()
    const intl = useIntl()

    let studentMainPageMatch = useRouteMatch({
        path: '/student',
        strict: true,
        sensitive: true,
    })

    const menuOptionsStudents = [
        {
            type: MenuOptionType.Logout,
            link: '/student/login',
            text: intl.formatMessage(studentScreenMessages.signOut),
            notFilterOut: true,
        },
    ]

    const [anchorEl, setAnchorEl] = useState(null)
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)

    const theme = useTheme()
    const smDownMatch = useMediaQuery(theme.breakpoints.down('sm'))

    const pathNames = location.pathname.split('/').filter((x) => x)
    const isMenuOpen = Boolean(anchorEl)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

    const [studentLocalizationLanguages, setStudentLocalizationLanguages] = useState([])

    const setupLocalizationLanguages = () => {
        if (props.student.languages?.length > 0) {
            var filteredLanugages = props.student.languages.filter((x) => x.id !== CapeeshLanguage.Bengali)
            setStudentLocalizationLanguages(filteredLanugages)
        }
    }

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const [isScrolled, setIsScrolled] = useState(false)

    const handleScroll = () => {
        // Set isScrolled true if scroll position is more than 0
        const scrolled = window.scrollY > 20
        setIsScrolled(scrolled)
    }

    useEffect(() => {
        setupLocalizationLanguages()
        props.dispatch(studentActions.getStudentLanguageMetadata())
        window.addEventListener('scroll', handleScroll)

        // Cleanup the listener when component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    useEffect(() => {
        if (props.student.languages) {
            setupLocalizationLanguages()
        }
    }, [props.student])

    const handleMenuClose = () => {
        setAnchorEl(null)
        handleMobileMenuClose()
    }

    const handleMenuItemClicked = (item) => {
        setAnchorEl(null)
        handleMobileMenuClose()

        if (item.type === MenuOptionType.QueryParam) {
            // maybe need too keep around some of the query params here
            switchToStudentSubPage(item.subPageType)
        } else if (item.type === MenuOptionType.FunctionCall) {
            item.callbackFunction()
        }
    }

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget)
    }

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null)
    }

    let menuOption = menuOptionsStudents

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            className={classes.dropdownMenu}>
            {menuOption.map(
                (option, index) =>
                    option.notFilterOut && (
                        <MenuItem
                            key={index}
                            id={index}
                            onClick={() => handleMenuItemClicked(option)}
                            component={option.link ? Link : ''}
                            to={option.link}>
                            {option.text}
                        </MenuItem>
                    )
            )}
        </Menu>
    )

    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
            className={classes.dropdownMenu}>
            {menuOption.map(
                (option, index) =>
                    option.notFilterOut && (
                        <MenuItem
                            key={index}
                            id={index}
                            onClick={() => handleMenuItemClicked(option)}
                            component={option.link ? Link : ''}
                            to={option.link}>
                            {option.text}
                        </MenuItem>
                    )
            )}
        </Menu>
    )
    const changeLocalizedLanguage = (e) => {
        props.dispatch(studentActions.setStudentDashboardLanguage(e.target.value))
        props.dispatch(studentActions.changeAppLanguage(e.target.value))
    }
    return (
        <div style={{ height: '60px' }} className={classes.root}>
            <AppBar
                className={classes.appBar}
                style={{
                    background: CapeeshColors.Primary900,
                    boxShadow: 'none',
                }}>
                <Toolbar className={classes.toolBar}>
                    {props.onDrawerToggle && (
                        <IconButton
                            className={classes.hamburgerButton}
                            onClick={props.onDrawerToggle}
                            aria-label={intl.formatMessage(studentScreenMessages.openNavigation)}
                            edge="start">
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Button
                        onClick={() => props.onGoToRoot()}
                        disableFocusRipple={true}
                        disableRipple={true}
                        className={classes.logoButton}>
                        {smDownMatch ? (
                            <CapeeshIcon width={42} height={42} className={classes.capeeshIcon} />
                        ) : (
                            <CapeeshLogo width={150} height={64} className={classes.capeeshLogo} />
                        )}
                    </Button>

                    <div className={classes.grow} />

                    <LocalizationSelector
                        localizationLanguages={studentLocalizationLanguages}
                        onChangeLocalizedLanguage={changeLocalizedLanguage}
                        dashboardLanguageId={props.student?.userDashboardLanguageId}
                    />

                    <div className={classes.sectionDesktop}>
                        <IconButton
                            aria-owns={isMenuOpen ? 'material-appbar' : null}
                            aria-haspopup="true"
                            className={classes.profileButton}
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                            disableRipple>
                            <Typography className={classes.username} color="primary">
                                {props?.userInfo?.name}
                            </Typography>
                            <AccountCircle />
                        </IconButton>
                    </div>
                    <div className={classes.sectionMobile}>
                        <IconButton aria-haspopup="true" onClick={handleMobileMenuOpen} color="inherit">
                            {props.student?.userinfo?.profilePictureUrl ? (
                                <Avatar
                                    alt={props.student?.userInfo?.name}
                                    src={props.student?.userInfo?.profilePictureUrl}
                                />
                            ) : (
                                <AccountCircle />
                            )}
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
            {renderMenu}
            {renderMobileMenu}
        </div>
    )
}

StudentTopBar.propTypes = {}

const mapStateToProps = (state) => {
    const { student, studentAuth } = state
    return {
        student: student,
        studentAuth: studentAuth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentTopBar)
